export enum AmplitudeEvents {
  lmsModuleViewed = 'LMS: Module Viewed',
  lmsCourseStarted = 'LMS: Course Started',
  lmsLessonStarted = 'LMS: Lesson Started',
  lmsLessonFinished = 'LMS: Lesson Finished',
  lmsCourseViewed = 'LMS: Course Viewed',
  lmsCourseReviewed = 'LMS: Course Reviewed',
}
